import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "orderByASC",
})
export class OrderByASC implements PipeTransform {
    transform(value: any, sport_id: any, ...args: any[]): any[] {
        if (!value || value.length === 0) {
            return [];
        }

        if (
            sport_id <= 64 ||
            (sport_id >= 91 && sport_id <= 89) ||
            (sport_id >= 247 && sport_id <= 258 && value.score !== null)
        ) {
            return value.sort((a, b) => {
                return a.score - b.score;
            });
        }

        if (
            sport_id >= 65 &&
            sport_id <= 98 &&
            value.some((item) => item.score !== null)
        ) {
            return value.sort((c, d) => {
                if (c.remark && d.remark) {
                    const cRemarkNum = parseInt(c.remark, 10);
                    const dRemarkNum = parseInt(d.remark, 10);

                    if (c.score === 0) return 1;
                    if (d.score === 0) return -1;

                    if (cRemarkNum > dRemarkNum) {
                        return 1;
                    } else if (cRemarkNum < dRemarkNum) {
                        return -1;
                    } else {
                        return 0;
                    }
                }

                if (c.score > d.score) {
                    return -1;
                } else if (c.score < d.score) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }

        return value;
    }
}
